module.exports = "/_next/static/images/piggy-line-3ca883f252f69d17dea4053cd5433528.svg";